const LS_WELCOME_KEY = 'optisigns_3_welcome_seen';

export function hasSeenWelcome(): boolean {
  try {
    return localStorage.getItem(LS_WELCOME_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(LS_WELCOME_KEY, 'true');
  } catch {
    /* noop */
  }
}
